import { SWReactIcons } from "@similarweb/icons";
import { PixelPlaceholderLoader, PlainTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";
import { translate } from "app/filters/i18nFilter";
import type { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";

import { LOADING_PLACEHOLDER_CHANGE_HEIGHT, LOADING_PLACEHOLDER_WIDTH } from "../constants";

import { ChangeContainer, LoaderWrapper, Title, TitleWrapper, Value } from "./styles";

type ChangeSchema = {
    title: string;
    value: string;
    change: string;
    tooltip: string;
    isIncreasing: boolean;
    granularity: BenchmarkGranularity;
    isLoading: boolean;
    isNotChanged?: boolean;
    className?: string;
    isInverted?: boolean;
};

const Change = ({
    title,
    value,
    change,
    tooltip,
    isIncreasing,
    isNotChanged,
    isInverted,
    className,
    granularity,
    isLoading,
}: ChangeSchema) => (
    <ChangeContainer className={className}>
        <TitleWrapper>
            <Title>{translate(title)}</Title>

            <PlainTooltip tooltipContent={translate(tooltip)}>
                <span>
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                    />
                </span>
            </PlainTooltip>
        </TitleWrapper>
        <Flex>
            {isLoading ? (
                <LoaderWrapper>
                    <PixelPlaceholderLoader
                        width={LOADING_PLACEHOLDER_WIDTH}
                        height={LOADING_PLACEHOLDER_CHANGE_HEIGHT}
                    />
                </LoaderWrapper>
            ) : (
                <>
                    <Value>{value}</Value>
                    <ChangeIndication
                        granularity={granularity}
                        changeValue={change}
                        isInverted={isInverted}
                        isIncreasing={isInverted ? !isIncreasing : isIncreasing}
                        isNotChanged={isNotChanged ?? false}
                    />
                </>
            )}
        </Flex>
    </ChangeContainer>
);

export default Change;
